import { useCallback, useEffect } from 'react';
import { useDispatch, connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  CircularProgress,
  Container
} from '@mui/material';

import surveyActions from 'modules/survey/actions';
import SurveyForm from 'modules/survey/components/form';
import LanguageSelectDialog from 'modules/survey/components/language-select-dialog';

const LANGUAGE_MAP = {
  kz: 'kz',
  ru: 'ru',
  en: 'en',
  undefined: 'kz'
}

export const SurveyContainer = (props) => {
  const { isLoading, status, selectLanguage, startMessage, isLastQuestion, cancelMessage, endMessage } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: surveyActions.FETCH_SURVEY_QUESTIONS })
  }, []);

  const { t, i18n } = useTranslation();
  const language = LANGUAGE_MAP[i18n.language];

  const handleDialogClose = useCallback(() => {
    dispatch({
      type: 'survey/setSurveyStatus',
      payload: { code: 'START_MESSAGE' },
    });
  }, []);

  if (isLoading) {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
          <CircularProgress style={{ marginBottom: 200 }} />
        </Box>
    );
  }

  if (status === 'EXPIRED' || status?.code === 'EXPIRED') {
    return (
        <Container>
          <Box sx={{ display: 'flex' }}>
            Survey no longer available!
          </Box>
        </Container>
    );
  }

  if (status?.code === 'SELECT_LANGUAGE') {
    return (
        <LanguageSelectDialog selectLanguage={selectLanguage} open={true} onClose={handleDialogClose} />
    );
  }

  const onStartHandler = () => {
    dispatch({
      type: 'survey/setSurveyStatus',
      payload: { code: 'SUCCESSFUL' },
    });
  }

  if (status?.code === 'START_MESSAGE') {
    if (startMessage?.[language]) {
      return (
          <div style={
            {
              padding:'10px 10px 10px 20px',
              display:"flex",
              justifyContent:'center',
              flexDirection:"column",
              alignItems:'center'
            }
          }>
            <div style={{fontSize:'2em'}}>{startMessage?.[language]}</div><br />
            <Button
                style={{
                  width:'300px'
                }}
                variant='contained'
                onClick={onStartHandler}
            >
              &nbsp;
              {t('start')}
            </Button>
          </div>
      );
    }
  }

  // TODO: add 'SUBMIT_LOADING' state
  if (status?.code === 'SUCCESSFUL' || status?.code === 'SUBMIT_LOADING' || status?.code === 'START_MESSAGE') {
    return (
        <SurveyForm disabled={status?.code === 'SUBMIT_LOADING'} />
    )
  }

  if (status === 'SUBMITTED' || status?.code === 'SUBMITTED') {
    let message = t('thanksForYourAnswers');

    if (isLastQuestion) {
      message = endMessage?.[language] ?? message;
    } else {
      message = cancelMessage?.[language] ?? message;
    }

    return (
        <div style={{fontSize:'2em'}}>
          {message}
        </div>
    )
  }

  if (status === 'FETCH_ERROR' || status?.code === 'FETCH_ERROR') {
    return (
        <div style={{fontSize:'2em'}}>
          {t('somethingWentWrong')}
        </div>
    )
  }

  if (status === 'NO_TOKEN' || status?.code === 'NO_TOKEN') {
    return (
        <div style={{fontSize:'2em'}}>
          {/* Отсутствует ссылка на опрос! */}
          {t('noSurveyReference')}
        </div>
    )
  }

  // ToDo: Now message is status?.message
  //       must be like object: status?.message[language]
  //       temporarily use this message: {t('noSurveyReference')}
  if (status === 'SURVEY_ERROR' || status?.code === 'SURVEY_ERROR') {
    return (
        <div style={{fontSize:'2em'}}>
          {t(status?.message)}
        </div>
    )
  }

  return (
      <div style={{fontSize:'2em'}}>{t('somethingWentWrong')}</div>
  );
}


const mapStateToProps = state => {
  return {
    isLoading: state.survey.isLoading,
    status: state.survey.status,
    startMessage: state.survey.startMessage,
    endMessage: state.survey.endMessage,
    cancelMessage: state.survey.cancelMessage,
    isLastQuestion: state.survey.isLastQuestion
  };
};

const SurveyContainerWrapper = connect(
    mapStateToProps,
    null, // mapDispatchToProps
)(SurveyContainer)


export default SurveyContainerWrapper;